// Work package "events": events and the guest views.
// This folder belongs to the WP (docs/v3/WORKPACKAGES.md 4). Other areas may
// import what this file exports (read-only use); they never edit this folder.
// Every route of this WP (docs/v3/COVERAGE.md).
import { extra, page, screen, type AreaRoute } from "../../routes/types";
import { PAGES } from "@convenor/shared";

// #51 (Event) shares /p/:projectId/activities/:id with the activities area,
// which owns that path and opens this area's event page (index.ts EventPage) for events.
export const routes: AreaRoute[] = [
  // 4a. Event
  screen(52, page(() => import("./pages/EditEventPage"), "EditEventPage")),
  screen(53, page(() => import("./pages/EventRsvpPage"), "EventRsvpPage")),
  // Marius's tabs: Programme, Logistics and Invitations › Automatic emails (new pages; the old paths stay).
  extra(PAGES.activityProgramme, page(() => import("./pages/EventProgrammePage"), "EventProgrammePage")),
  // E7 (retest 30 Oct): "Preview as guests see it".
  screen(159, page(() => import("./pages/ProgrammeGuestPreviewPage"), "ProgrammeGuestPreviewPage")),
  extra(PAGES.activityLogistics, page(() => import("./pages/EventLogisticsPage"), "EventLogisticsPage")),
  extra(PAGES.activityEmails, page(() => import("./pages/EventEmailsPage"), "EventEmailsPage")),
  extra(PAGES.activitySpeakers, page(() => import("./pages/EventSpeakerRequestsPage"), "EventSpeakerRequestsPage")),
  extra(PAGES.activitySpeakersPreview, page(() => import("./pages/SpeakerFormPreviewPage"), "SpeakerFormPreviewPage")),
  // Round 4: Invitations › Invitation email and its full preview.
  extra(PAGES.activityInvitationsEmail, page(() => import("./pages/InvitationEmailPage"), "InvitationEmailPage")),
  extra(PAGES.activityInvitationsEmailPreview, page(() => import("./pages/InvitationEmailPage"), "InvitationEmailPreviewPage")),
  screen(54, page(() => import("./pages/AddQuestionPage"), "AddQuestionPage")),
  extra(PAGES.activityRsvpQuestion, page(() => import("./pages/AddQuestionPage"), "AddQuestionPage")),
  screen(55, page(() => import("./pages/EventRegistrationsPage"), "EventRegistrationsPage")),
  screen(56, page(() => import("./pages/EventParticipantsPage"), "EventParticipantsPage")),
  extra(PAGES.activityParticipantsExport, page(() => import("./pages/ParticipantsExportPage"), "ParticipantsExportPage")),
  extra(PAGES.activityParticipantSpeaker, page(() => import("./pages/SpeakerDetailsPage"), "SpeakerDetailsPage")),
  screen(57, page(() => import("./pages/InvitePage"), "InvitePage")),
  screen(58, page(() => import("./pages/EventCheckInPage"), "EventCheckInPage")),
  screen(59, page(() => import("./pages/WalkInPage"), "WalkInPage")),
  screen(60, page(() => import("./pages/EventFollowUpPage"), "EventFollowUpPage")),
  screen(61, page(() => import("./pages/FeedbackFormPage"), "FeedbackFormPage")),
  screen(62, page(() => import("./pages/EventFeedbackPage"), "EventFeedbackPage")),
  // 11. External views
  screen(145, page(() => import("./pages/RsvpPage"), "RsvpPage")),
  screen(146, page(() => import("./pages/RsvpConfirmedPage"), "RsvpConfirmedPage")),
  screen(147, page(() => import("./pages/FeedbackPage"), "FeedbackPage")),
  screen(148, page(() => import("./pages/CheckinRoomPage"), "CheckinRoomPage")),
  // The speaker's own details form (personal link from the speaker details request).
  extra(PAGES.speaker, page(() => import("./pages/SpeakerFormPage"), "SpeakerFormPage")),
  // Round 4 (D8): the shared RSVP link of an event.
  // A known stakeholder confirms a reply given through the shared link (final review X1).
  extra(PAGES.rsvpConfirm, page(() => import("./pages/RsvpConfirmReplyPage"), "RsvpConfirmReplyPage"), { shell: "guest" }),
  extra(PAGES.rsvp, page(() => import("./pages/RsvpLinkPage"), "RsvpLinkPage"), { shell: "guest" }),
  // Legacy public event forms (v2 links in the wild keep working).
  extra(PAGES.publicForm, page(() => import("./pages/PublicFormPage"), "PublicFormPage")),
];
